import { AxiosClient } from "@/app/shared/services";

const state = {
    auth: {
        creditionals: {
            phone: "",
            password: "",
        },
        api_key: "",
        token: localStorage.getItem("token") || "",
        refreshToken: localStorage.getItem("refreshToken") || "",
        authUser: {},
        loginIsLoading: false,
        status: "",
        isAdmin: localStorage.getItem("isAdmin") || 0,
    },
};

const getters = {
    AUTH_CREDITIONALS: (state) => state.auth.creditionals,
    AUTH_TOKEN: (state) => state.auth.token,
    REFRESH_TOKEN: (state) => state.auth.refreshToken,
    API_KEY:(state) => state.auth.api_key,
    AUTH_USER: (state) => state.auth.authUser,
    AUTH_IS_LOADING: (state) => state.auth.loginIsLoading,
    AUTH_STATUS: (state) => state.auth.status,
    IS_LOGGED_IN: (state) => !!state.auth.token,
    IS_NEW_PASSWORD_WAS_CREATED: (state) => state.restorePassword.newPasswordWasCreated,

    IS_NEW_PASSWORD_MODAL_OPEN: (state) => state.restorePassword.isModalOpen,
    SHOW_CREDIT_SCORE_MODAL: (state) => state.auth.authUser.credit_score === null,

    IS_CLIENT: (state) => !state.auth.isAdmin,
    IS_ADMIN: (state) => !!state.auth.isAdmin,
};

const mutations = {
    SET_AUTH_CREDITIONALS: (state, creditionals) => {
        state.auth.creditionals.email = creditionals.email;
        state.auth.creditionals.phone = creditionals.phone;
        state.auth.creditionals.password = creditionals.password;
    },
    AUTH_SUCCESS: (state, token, refreshToken, user, api_key) => {
        state.auth.token = token;
        state.auth.refreshToken = refreshToken;
        state.auth.authUser = user;
        state.auth.api_key = api_key;
        state.auth.status = "success";
    },
    AUTH_FAILED: (state) => {
        state.auth.token = "";
        state.auth.authUser = {};
        state.auth.status = "failed";
    },
    SET_AUTH_IS_LOADING: (state, isLoading) => {
        state.auth.loginIsLoading = isLoading;
    },
    SET_AUTH_USER: (state, user) => {
        state.auth.authUser = user;
    },
    AUTH_LOGOUT: (state) => {
        state.auth.token = "";
        state.auth.status = "";
        state.auth.authUser = {};
        state.auth.api_key = "";
        state.auth.isAdmin = false;
    },
    SET_AUTH_AS_ADMIN: (state) => {
        state.auth.isAdmin = true;
    },
};

const actions = {
    SET_AUTH_USER: (context, user) => {
        context.commit("AUTH_SUCCESS", user.token, user.refresh_token, user, user.api_key);
        localStorage.setItem("token", user.token);
        localStorage.setItem("refreshToken", user.refresh_token);
        AxiosClient.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    },

    SET_AUTH_CREDITIONALS: (context, payload) => {
        context.commit("SET_AUTH_CREDITIONALS", payload);
    },

    AUTH_BY_TOKEN: (context, token) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/profile/loginbytoken", { token })
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data,
                        data.data.api_key,
                    );
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve(data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    AUTH_BY_API_KEY: (context, api_key) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.get(`/profile/loginbyapikey?api_key=${api_key}`)
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data,
                        data.data.api_key,
                    );
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve(data.data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    CREDENTIALS_BY_API_KEY: (context, api_key) => {
        return new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.get(`/profile/loginbyapikey?api_key=${api_key}`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        });
    },

    ADMIN_AUTH: (context) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/admin/login", state.auth.creditionals)
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data,
                        data.data.api_key,
                    );
                    context.commit("SET_AUTH_AS_ADMIN");
                    localStorage.setItem("isAdmin", 1);
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve();
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    LOGOUT: (context) =>
        new Promise((resolve, reject) => {
            AxiosClient.post("/profile/logout")
                .then(() => resolve())
                .catch(() => reject())
                .finally(function () {
                    context.commit("AUTH_LOGOUT");
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("isAdmin");
                    delete AxiosClient.defaults.headers.common.Authorization;
                });
        }),

    GET_AUTH_USER: (context) => {
        context.commit("SET_AUTH_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            const path = "/admin/authuser";

            AxiosClient.get(path)
                .then((data) => {
                    context.commit("SET_AUTH_USER", data.data);
                    resolve(data.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
};
